"use strict";
const ezuiTokens = {
  "breakpoint.xs": "0px",
  "breakpoint.sm": "480px",
  "breakpoint.md": "640px",
  "breakpoint.lg": "1024px",
  "breakpoint.xl": "1360px",
  "breakpoint.xxl": "1920px",
  "color.blue.100": "#d0dbff",
  "color.blue.200": "#a2b8ff",
  "color.blue.300": "#7394ff",
  "color.blue.400": "#4571ff",
  "color.blue.500": "#164dff",
  "color.blue.600": "#113abf",
  "color.blue.700": "#0b2780",
  "color.blue.800": "#061340",
  "color.green.100": "#ccfaef",
  "color.green.200": "#99f5df",
  "color.green.300": "#66efce",
  "color.green.400": "#33eabe",
  "color.green.500": "#00e5ae",
  "color.green.600": "#00ac83",
  "color.green.700": "#007357",
  "color.green.800": "#00392c",
  "color.red.100": "#fedede",
  "color.red.200": "#fdbebd",
  "color.red.300": "#fd9d9b",
  "color.red.400": "#fc7d7a",
  "color.red.500": "#fb5c59",
  "color.red.600": "#bc4543",
  "color.red.700": "#7e2e2d",
  "color.red.800": "#3f1716",
  "color.purple.100": "#ecd7fc",
  "color.purple.200": "#d9b0f8",
  "color.purple.300": "#c588f5",
  "color.purple.400": "#b261f1",
  "color.purple.500": "#9f39ee",
  "color.purple.600": "#772bb0",
  "color.purple.700": "#501d77",
  "color.purple.800": "#280e3c",
  "color.yellow.100": "#fff8e0",
  "color.yellow.200": "#fff3c9",
  "color.yellow.300": "#ffeba4",
  "color.yellow.400": "#fee281",
  "color.yellow.500": "#f4d35e",
  "color.yellow.600": "#e7b83f",
  "color.yellow.700": "#d88c34",
  "color.yellow.800": "#af640c",
  "color.gray.100": "#e2e7f0",
  "color.gray.200": "#c6cfe0",
  "color.gray.300": "#a9b6d1",
  "color.gray.400": "#8d9ec1",
  "color.gray.500": "#7086b2",
  "color.gray.600": "#47547f",
  "color.gray.700": "#384359",
  "color.gray.800": "#1c222d",
  "color.gray.900": "#000000",
  "color.gray.050": "#f1f1f1",
  "color.gray.000": "#ffffff",
  "color.off_white": "#fff9f5",
  "color.black": "#000000",
  "color.white": "#ffffff",
  "font.family.sans": 'Poppins, "Poppins Fallback"',
  "font.family.mono": 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  "font.family.icon": '"Material Symbols Outlined"',
  "font.size.25": "10px",
  "font.size.50": "12px",
  "font.size.75": "13px",
  "font.size.100": "15px",
  "font.size.200": "19px",
  "font.size.300": "23px",
  "font.size.400": "33px",
  "font.size.500": "46px",
  "font.size.600": "52px",
  "font.line_height.1": "16px",
  "font.line_height.2": "24px",
  "font.line_height.3": "32px",
  "font.line_height.4": "40px",
  "font.line_height.5": "56px",
  "font.line_height.6": "64px",
  "font.weight.normal": "400",
  "font.weight.medium": "500",
  "font.weight.semibold": "600",
  "font.weight.bold": "700",
  "font.letter_spacing.tighten_6": "-1.5px",
  "font.letter_spacing.tighten_5": "-0.5px",
  "font.letter_spacing.tighten_4": "-0.4px",
  "font.letter_spacing.tighten_3": "-0.25px",
  "font.letter_spacing.tighten_2": "-0.15px",
  "font.letter_spacing.tighten_1": "-0.1px",
  "font.letter_spacing.normal": "0",
  "font.letter_spacing.widen_1": "0.1px",
  "font.letter_spacing.widen_2": "0.15px",
  "font.letter_spacing.widen_3": "0.25px",
  "font.letter_spacing.widen_4": "0.4px",
  "font.letter_spacing.widen_5": "0.5px",
  "font.letter_spacing.widen_6": "1.5px",
  "font.style.heading1.family": 'Poppins, "Poppins Fallback"',
  "font.style.heading1.weight": "500",
  "font.style.heading1.size": "52px",
  "font.style.heading1.letter_spacing": "-0.5px",
  "font.style.heading1.line_height": "64px",
  "font.style.heading2.family": 'Poppins, "Poppins Fallback"',
  "font.style.heading2.weight": "500",
  "font.style.heading2.size": "46px",
  "font.style.heading2.letter_spacing": "0",
  "font.style.heading2.line_height": "56px",
  "font.style.heading3.family": 'Poppins, "Poppins Fallback"',
  "font.style.heading3.weight": "400",
  "font.style.heading3.size": "33px",
  "font.style.heading3.letter_spacing": "0.25px",
  "font.style.heading3.line_height": "40px",
  "font.style.heading4.family": 'Poppins, "Poppins Fallback"',
  "font.style.heading4.weight": "400",
  "font.style.heading4.size": "23px",
  "font.style.heading4.letter_spacing": "0",
  "font.style.heading4.line_height": "32px",
  "font.style.heading5.family": 'Poppins, "Poppins Fallback"',
  "font.style.heading5.weight": "600",
  "font.style.heading5.size": "19px",
  "font.style.heading5.letter_spacing": "0.15px",
  "font.style.heading5.line_height": "24px",
  "font.style.subtitle1.family": 'Poppins, "Poppins Fallback"',
  "font.style.subtitle1.weight": "600",
  "font.style.subtitle1.size": "15px",
  "font.style.subtitle1.letter_spacing": "0.15px",
  "font.style.subtitle1.line_height": "24px",
  "font.style.subtitle2.family": 'Poppins, "Poppins Fallback"',
  "font.style.subtitle2.weight": "500",
  "font.style.subtitle2.size": "13px",
  "font.style.subtitle2.letter_spacing": "0.1px",
  "font.style.subtitle2.line_height": "16px",
  "font.style.body1.family": 'Poppins, "Poppins Fallback"',
  "font.style.body1.weight": "400",
  "font.style.body1.size": "15px",
  "font.style.body1.letter_spacing": "0.5px",
  "font.style.body1.line_height": "24px",
  "font.style.body2.family": 'Poppins, "Poppins Fallback"',
  "font.style.body2.weight": "400",
  "font.style.body2.size": "13px",
  "font.style.body2.letter_spacing": "0.25px",
  "font.style.body2.line_height": "16px",
  "font.style.caption.family": 'Poppins, "Poppins Fallback"',
  "font.style.caption.weight": "400",
  "font.style.caption.size": "12px",
  "font.style.caption.letter_spacing": "0.4px",
  "font.style.caption.line_height": "16px",
  "font.style.overline.family": 'Poppins, "Poppins Fallback"',
  "font.style.overline.weight": "400",
  "font.style.overline.size": "10px",
  "font.style.overline.letter_spacing": "1.5px",
  "font.style.overline.line_height": "16px",
  "font.style.button.family": 'Poppins, "Poppins Fallback"',
  "font.style.button.weight": "500",
  "font.style.button.size": "15px",
  "font.style.button.letter_spacing": "0",
  "font.style.button.line_height": "24px",
  "font.style.small_button.family": 'Poppins, "Poppins Fallback"',
  "font.style.small_button.weight": "500",
  "font.style.small_button.size": "12px",
  "font.style.small_button.letter_spacing": "0",
  "font.style.small_button.line_height": "16px",
  "font.responsive_mapping.heading1": "heading2",
  "font.responsive_mapping.heading2": "heading3",
  "font.responsive_mapping.heading3": "heading4",
  "opacity.underlay": 0.4,
  "shadow.button": "0px 0px 0px 3px rgba(69, 132, 255, 0.4)",
  "shadow.input": "0px 0px 0px 3px rgba(1, 70, 130, 0.25)",
  "shadow.overlay": "0px 4px 8px rgba(141, 158, 193, 0.25)",
  "shadow.overlay_subdued": "1px 1px 4px rgba(141, 158, 193, 0.5)",
  "shadow.modal": "0px 8px 16px 0px hsla(220, 23%, 28%, 0.5)",
  "shadow.stuck-from-top": "0px 4px 4px 0px hsla(221, 30%, 74%, 0.25)",
  "shadow.stuck-from-bottom": "0px -4px 4px 0px hsla(221, 30%, 74%, 0.25)",
  "shape.border_radius.sm": "3px",
  "shape.border_radius.md": "5px",
  "shape.border_radius.lg": "8px",
  "shape.border_radius.xl": "16px",
  "shape.border_width.1": "1px",
  "size.icon.xs": "16px",
  "size.icon.sm": "20px",
  "size.icon.md": "24px",
  "size.icon.lg": "32px",
  "size.icon.xl": "40px",
  "size.icon.2xl": "48px",
  "size.icon.3xl": "56px",
  "space.0": "0",
  "space.1": "8px",
  "space.2": "16px",
  "space.3": "24px",
  "space.4": "32px",
  "space.5": "40px",
  "space.6": "48px",
  "space.7": "56px",
  "space.8": "64px",
  "space.9": "72px",
  "space.10": "80px",
  "space.0.125": "1px",
  "space.0.25": "2px",
  "space.0.5": "4px",
  "space.1.5": "12px",
  "space.4.5": "36px",
  "theme.base.color.background": "#ffffff",
  "theme.base.color.background.black.bold": "#1c222d",
  "theme.base.color.background.black.subtle": "#f1f1f1",
  "theme.base.color.background.danger": "#fb5c59",
  "theme.base.color.background.danger.bold": "#bc4543",
  "theme.base.color.background.danger.hovered": "#bc4543",
  "theme.base.color.background.danger.pressed": "#7e2e2d",
  "theme.base.color.background.danger.subtle": "#fedede",
  "theme.base.color.background.disabled.subtler": "#f1f1f1",
  "theme.base.color.background.disabled.subtle": "#e2e7f0",
  "theme.base.color.background.disabled": "#c6cfe0",
  "theme.base.color.background.disabled.bolder": "#8d9ec1",
  "theme.base.color.background.gray.subtle": "#f1f1f1",
  "theme.base.color.background.gray": "#e2e7f0",
  "theme.base.color.background.gray.hovered": "#c6cfe0",
  "theme.base.color.background.gray.bold": "#47547f",
  "theme.base.color.background.inverse.bold": "#e2e7f0",
  "theme.base.color.background.inverse.subtle": "#f1f1f1",
  "theme.base.color.background.neutral": "#061340",
  "theme.base.color.background.neutral.hovered": "#000000",
  "theme.base.color.background.neutral.pressed": "#0b2780",
  "theme.base.color.background.primary": "#164dff",
  "theme.base.color.background.primary.bold": "#113abf",
  "theme.base.color.background.primary.bolder": "#0b2780",
  "theme.base.color.background.primary.hovered": "#113abf",
  "theme.base.color.background.primary.pressed": "#0b2780",
  "theme.base.color.background.primary.subtler": "#4571ff",
  "theme.base.color.background.primary.subtle": "#d0dbff",
  "theme.base.color.background.secondary": "#9f39ee",
  "theme.base.color.background.secondary.bold": "#772bb0",
  "theme.base.color.background.secondary.hovered": "#772bb0",
  "theme.base.color.background.secondary.pressed": "#501d77",
  "theme.base.color.background.secondary.subtle": "#ecd7fc",
  "theme.base.color.background.success": "#00e5ae",
  "theme.base.color.background.success.bold": "#00ac83",
  "theme.base.color.background.success.hovered": "#00ac83",
  "theme.base.color.background.success.pressed": "#007357",
  "theme.base.color.background.success.subtle": "#ccfaef",
  "theme.base.color.background.warning.bold": "#f4d35e",
  "theme.base.color.background.warning.subtle": "#ffeba4",
  "theme.base.color.background.underlay": "#061340",
  "theme.base.color.border": "#a9b6d1",
  "theme.base.color.border.subtle": "#e2e7f0",
  "theme.base.color.border.bolder": "#8d9ec1",
  "theme.base.color.border.boldest": "#7086b2",
  "theme.base.color.border.danger": "#fb5c59",
  "theme.base.color.border.danger.bolder": "#bc4543",
  "theme.base.color.border.warning": "#f4d35e",
  "theme.base.color.border.selected": "#164dff",
  "theme.base.color.border.success": "#00ac83",
  "theme.base.color.border.resting": "#c6cfe0",
  "theme.base.color.border.incomplete": "#7086b2",
  "theme.base.color.border.engaged": "#7086b2",
  "theme.base.color.border.support": "#061340",
  "theme.base.color.border.support.hovered": "#000000",
  "theme.base.color.border.support.pressed": "#384359",
  "theme.base.color.border.inverse": "#ffffff",
  "theme.base.color.border.inverse.hovered": "#e2e7f0",
  "theme.base.color.border.inverse.pressed": "#c6cfe0",
  "theme.base.color.border.disabled": "#a9b6d1",
  "theme.base.color.border.disabled.subtler": "#c6cfe0",
  "theme.base.color.scrollbar.thumb": "#7086b2",
  "theme.base.color.scrollbar.track": "#f1f1f1",
  "theme.base.color.selector": "#00ac83",
  "theme.base.color.surface.card.primary": "#ffffff",
  "theme.base.color.surface.card.secondary": "#f1f1f1",
  "theme.base.color.surface.overlay": "#ffffff",
  "theme.base.color.surface.overlay.hovered": "#f1f1f1",
  "theme.base.color.separator.primary": "#061340",
  "theme.base.color.separator.neutral": "#7086b2",
  "theme.base.color.separator.inverse": "#ffffff",
  "theme.base.color.text": "#061340",
  "theme.base.color.text.primary": "#061340",
  "theme.base.color.text.action": "#164dff",
  "theme.base.color.text.subdued": "#47547f",
  "theme.base.color.text.disabled": "#a9b6d1",
  "theme.base.color.text.heading": "#061340",
  "theme.base.color.text.inverse": "#ffffff",
  "theme.base.color.text.engaged": "#000000",
  "theme.base.color.text.gray.resting": "#7086b2",
  "theme.base.color.text.gray.bold": "#1c222d",
  "theme.base.color.text.black.inverse.bold": "#ffffff",
  "theme.base.color.text.black.inverse.subtle": "#061340",
  "theme.base.color.text.danger": "#bc4543",
  "theme.base.color.text.danger.bold": "#3f1716",
  "theme.base.color.text.danger.inverse": "#061340",
  "theme.base.color.text.danger.inverse.bold": "#ffffff",
  "theme.base.color.text.danger.inverse.pressed": "#061340",
  "theme.base.color.text.danger.inverse.subtle": "#061340",
  "theme.base.color.text.gray.inverse.bold": "#ffffff",
  "theme.base.color.text.gray.inverse.subtle": "#061340",
  "theme.base.color.text.inverse.inverse.bold": "#000000",
  "theme.base.color.text.inverse.inverse.subtle": "#061340",
  "theme.base.color.text.primary.inverse": "#ffffff",
  "theme.base.color.text.primary.inverse.bold": "#ffffff",
  "theme.base.color.text.primary.inverse.subtle": "#061340",
  "theme.base.color.text.secondary.bold": "#280e3c",
  "theme.base.color.text.secondary.inverse.bold": "#ffffff",
  "theme.base.color.text.secondary.inverse.subtle": "#061340",
  "theme.base.color.text.success.bold": "#00392c",
  "theme.base.color.text.success.inverse": "#061340",
  "theme.base.color.text.success.inverse.bold": "#ffffff",
  "theme.base.color.text.success.inverse.subtle": "#061340",
  "theme.base.color.text.success.inverse.pressed": "#ffffff",
  "theme.base.color.text.warning.inverse.bold": "#000000",
  "theme.base.color.text.warning.inverse.subtle": "#061340",
  "theme.base.color.text.code.base": "#061340",
  "theme.base.color.text.code.lineNumber": "#47547f",
  "theme.base.color.text.code.comment": "#8d9ec1",
  "theme.base.color.text.code.punctuation": "#384359",
  "theme.base.color.text.code.property": "#7e2e2d",
  "theme.base.color.text.code.selector": "#007357",
  "theme.base.color.text.code.operator": "#af640c",
  "theme.base.color.text.code.variable": "#d88c34",
  "theme.base.color.text.code.function": "#bc4543",
  "theme.base.color.text.code.keyword": "#164dff",
  "theme.base.color.primary.800": "#061340",
  "theme.base.color.primary.700": "#0b2780",
  "theme.base.color.primary.600": "#113abf",
  "theme.base.color.primary.500": "#164dff",
  "theme.base.color.primary.400": "#4571ff",
  "theme.base.color.primary.300": "#7394ff",
  "theme.base.color.primary.200": "#a2b8ff",
  "theme.base.color.primary.100": "#d0dbff",
  "theme.base.color.secondary.800": "#280e3c",
  "theme.base.color.secondary.700": "#501d77",
  "theme.base.color.secondary.600": "#772bb0",
  "theme.base.color.secondary.500": "#9f39ee",
  "theme.base.color.secondary.400": "#b261f1",
  "theme.base.color.secondary.300": "#c588f5",
  "theme.base.color.secondary.200": "#d9b0f8",
  "theme.base.color.secondary.100": "#ecd7fc",
  "theme.base.color.positive.800": "#00392c",
  "theme.base.color.positive.700": "#007357",
  "theme.base.color.positive.600": "#00ac83",
  "theme.base.color.positive.500": "#00e5ae",
  "theme.base.color.positive.400": "#33eabe",
  "theme.base.color.positive.300": "#66efce",
  "theme.base.color.positive.200": "#99f5df",
  "theme.base.color.positive.100": "#ccfaef",
  "theme.base.color.negative.800": "#3f1716",
  "theme.base.color.negative.700": "#7e2e2d",
  "theme.base.color.negative.600": "#bc4543",
  "theme.base.color.negative.500": "#fb5c59",
  "theme.base.color.negative.400": "#fc7d7a",
  "theme.base.color.negative.300": "#fd9d9b",
  "theme.base.color.negative.200": "#fdbebd",
  "theme.base.color.negative.100": "#fedede",
  "theme.base.color.warning.800": "#af640c",
  "theme.base.color.warning.700": "#d88c34",
  "theme.base.color.warning.600": "#e7b83f",
  "theme.base.color.warning.500": "#f4d35e",
  "theme.base.color.warning.400": "#fee281",
  "theme.base.color.warning.300": "#ffeba4",
  "theme.base.color.warning.200": "#fff3c9",
  "theme.base.color.warning.100": "#fff8e0",
  "theme.base.color.neutral.900": "#000000",
  "theme.base.color.neutral.800": "#1c222d",
  "theme.base.color.neutral.700": "#384359",
  "theme.base.color.neutral.600": "#47547f",
  "theme.base.color.neutral.500": "#7086b2",
  "theme.base.color.neutral.400": "#8d9ec1",
  "theme.base.color.neutral.300": "#a9b6d1",
  "theme.base.color.neutral.200": "#c6cfe0",
  "theme.base.color.neutral.100": "#e2e7f0",
  "theme.base.color.neutral.050": "#f1f1f1",
  "theme.base.color.neutral.000": "#ffffff",
  "theme.base.font.family": 'Poppins, "Poppins Fallback"',
  "theme.base.shadow.button": "0px 0px 0px 3px rgba(69, 132, 255, 0.4)",
  "theme.base.shadow.overlay": "0px 4px 8px rgba(141, 158, 193, 0.25)",
  "theme.base.shadow.overlay.subdued": "1px 1px 4px rgba(141, 158, 193, 0.5)",
  "z-index.input_icon": "1",
  "z-index.notification": "999999",
  "z-index.modal": "1300"
};
exports.ezuiTokens = ezuiTokens;
